import { Link } from "react-router-dom";
import "./FooterComponent.scss";
import { getRouterForSection, routesMap } from "../../routes";
import CARDS_LIST_TO_VIEW from "../../utils/Constans";


/**
 * @function FooterComponent footer of the aplication
 * @returns {JSX.Element}
*/
const FooterComponent = () => {

    return (
        <footer className="p-absolute w-100 Footer ">
            <div className="row topFooter">
                <div className="col-auto">
                    <ul className="Footer__List first">
                        <div className="mb-4 title" tabIndex="0" role="contentinfo" aria-label="Area del sito">AREA DEL SITO</div>
                        {
                            CARDS_LIST_TO_VIEW.map( card => {
                                const { title, tipologia, id } = card;
                                return (
                                    <li key={ title } className="Footer__link pb-2">
                                        <Link
                                            to={ getRouterForSection(tipologia) }
                                            rel={ `rel${ id }` }>
                                            { title }
                                        </Link>
                                    </li>
                                );
                            } )
                        }
                    </ul>
                </div>
                <div className="col-auto">
                    <ul className="Footer__List first">
                        <div className="mb-4 title" tabIndex="0" role="contentinfo" aria-label="Link utili">LINK UTILI</div>
                        <li className="Footer__link pb-2"><Link to={ routesMap.ARCHIVIO } rel="relArchivioRSSR" className="">Archivio RSSR</Link></li>
                    </ul>
                </div>
            </div>
            <hr className="Footer__separator" />
            <div className="row">
                <div className="col-12 col-xl-5">
                    <div className="row">
                        <div className="col-auto Footer__link subFooter"> <Link to={ routesMap.INFORMATIVA_PRIVACY } rel="relHome">Privacy</Link></div>
                        <div className="col-auto Footer__link subFooter"><Link to={ routesMap.COOKIE } rel="relCookie">Cookie</Link></div>
                        <div className="col-auto Footer__link subFooter"><Link to={ routesMap.ACCESSIBILITA } rel="relAccessibilità" className="disabled">Accessibilità</Link></div>
                        {/* <div className="col-auto Footer__link"><a>Mappa del sitio</a></div> */ }
                    </div>
                </div>
                <div className="col-12 col-xl-7 text-xl-end subFooter mt-2 mt-xl-0" >
                    <div tabIndex="0" role="contentinfo" aria-label="Copyright Azienda Zero 2023. Tutti i diritti sono riservati - P.I. 05018720283">Copyright Azienda Zero 2023. Tutti i diritti sono riservati - P.I. 05018720283</div>
                </div>
            </div>
        </footer >
    );
};

FooterComponent.propTypes = {};

FooterComponent.defaultProps = {};

export default FooterComponent;